import { Component, signal } from '@angular/core';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { isDismissed, setDismissed } from '../../core/storage/dismissed-storage';
import { LicenseType } from '../models/school-license.model';

/** Kdo může doporučovat: jen škola s aktivní placenou licencí. Zkušební licence nestačí. */
export function canRefer(type: LicenseType | undefined): boolean {
  return type === 'start' || type === 'premium';
}

export const REFERRAL_DISCOUNT_PERCENT = 20;

/** Sekce programu doporučení na webu, včetně objednávkového formuláře pro novou školu. */
export const REFERRAL_PROGRAM_URL = 'https://mapavyuky.cz/#doporuceni';

/**
 * Skrytí platí jen do konce přihlášení: `AuthService.clearSession()` klíč maže, takže se karta po
 * každém dalším přihlášení připomene znovu.
 */
export const REFERRAL_DISMISSED_KEY = 'referral-card-dismissed';

/**
 * Pozvánka do programu doporučení: škola s placenou licencí doporučí Mapu výuky jiné škole a obě
 * dostanou slevu na příští licenci. Nic se tu neodesílá — doporučení uvádí nová škola ve svém
 * objednávkovém formuláři na webu, takže karta jen vysvětluje, co tam má vyplnit, a podmínky.
 *
 * Po skrytí zůstává karta schovaná všude až do dalšího přihlášení.
 */
@Component({
  selector: 'app-referral-card',
  imports: [MatButton, MatIconButton, MatIcon],
  host: {
    '[class.hidden]': 'hidden()',
  },
  templateUrl: './referral-card.html',
})
export class ReferralCard {
  readonly discount = REFERRAL_DISCOUNT_PERCENT;
  readonly programUrl = REFERRAL_PROGRAM_URL;

  readonly conditionsOpen = signal(false);

  readonly hidden = signal(isDismissed(REFERRAL_DISMISSED_KEY));

  toggleConditions(): void {
    this.conditionsOpen.update((open) => !open);
  }

  dismiss(): void {
    setDismissed(REFERRAL_DISMISSED_KEY);
    this.hidden.set(true);
  }
}
